import button from '../../atoms/button/button';

document.querySelectorAll('.channel-list__section').forEach(($section) => {
  // Get references
  const $items = $section.querySelectorAll('.channel-list__item');
  const $itemCount = $items.length;

  if ($itemCount > 18) {
    const $button = button({
      link: false,
      style: 'secondary',
      icon: 'hook-bottom',
      text: 'Alle anzeigen',
      hiddenText: false,
      classes: 'channel-list__button',
    });

    $button.addEventListener('click', () => {
      $section.classList.add('channel-list__section--open');
      // Hide Load-More button
      $button.style.display = 'none';
    }, false);

    $section.appendChild($button);
  }
});
